import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import AgentLayout from "../components/AgentLayout";

const BetDelayManager = () => {
    const [eventLimits, setEventLimits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [search, setSearch] = useState("");

    const gameTypes = {
        1: "Cricket",
        2: "Football",
        3: "Tennis",
        4: "Horseracing",
        5: "Greyhound",
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    "http://localhost:5001/master/betdelay/event-limits"
                );

                setEventLimits(response.data.data);
            } catch (error) {
                setError("Unable to load bet delay data.");
            }

            setLoading(false);
        };

        fetchData();
    }, []);

    const filteredLimits = eventLimits.filter((item) =>
        `${item.name || ""} ${gameTypes[item.game_type] || "Unknown"}`
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    return (
        <AgentLayout>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            &nbsp;&nbsp;Bet Delay Manager
                        </div>

                        <div className="panel-body">
                            <div style={{ marginBottom: "10px", marginTop: "10px", marginLeft: "5px" }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search.."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    style={{ width: "250px", display: "inline-block" }}
                                />

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    style={{ marginLeft: "10px" }}
                                    onClick={() => setSearch(searchInput.trim())}
                                >
                                    Search
                                </button>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Value</th>
                                            <th>Game Type</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="4">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="4">{error}</td>
                                            </tr>
                                        ) : filteredLimits.length > 0 ? (
                                            filteredLimits.map((item) => (
                                                <tr key={item._id}>
                                                    <td>{item.name}</td>
                                                    <td>{item.value} Sec</td>
                                                    <td>
                                                        {gameTypes[item.game_type] || "Unknown"}
                                                    </td>
                                                    <td>
                                                        <Link to={`/agent/edit-betdelay?id=${item._id}`}>
                                                            Edit
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">No records found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AgentLayout>
    );
};

export default BetDelayManager;